import Vue from "vue";
import {AllocationType} from "@/modules/budget/AllocationType";
import {Budget} from "@/modules/budget/Budget";
import BudgetAllocationRepository from "@/repositories/budget/BudgetAllocationRepository";
import _ from "lodash";

export interface BudgetAllocation {
    uuid: string;
    label: string;
    allocationType: AllocationType;
    budget: Budget;
}

export default {
    state: {
        budgetAllocations: [],
    },
    mutations: {
        setBudgetAllocations: (state: any, budgetAllocations: BudgetAllocation[]) => {
            Vue.set(state, "budgetAllocations", budgetAllocations);
        },
    },
    getters: {
        getBudgetAllocations: (state: any): BudgetAllocation[] => {
            return state.budgetAllocations;
        },
        getBudgetAllocationsByType: (state: any) => (typeUuid: string): BudgetAllocation[] => {
            return _.filter(state.budgetAllocations, (budgetAllocation: BudgetAllocation) => {
                return _.get(budgetAllocation, "allocationType.uuid", null) === typeUuid;
            });
        },
        getBudgetAllocationsByBudget: (state: any) => (budgetUuid: string): BudgetAllocation[] => {
            return _.filter(state.budgetAllocations, (budgetAllocation: BudgetAllocation) => {
                return _.get(budgetAllocation, "budget.uuid", null) === budgetUuid;
            });
        },
    },
    actions: {
        loadBudgetAllocations: ({ commit }: any) => {
            commit("setBudgetAllocations", []);
            BudgetAllocationRepository.get().then((data: any) => {
                commit("setBudgetAllocations", data);
            });
        },
    },
};
